import React from 'react';

const OperatingLocationsPage: React.FC = () => {
  return <div></div>;
};

export default OperatingLocationsPage;